import { logger } from '@user-portal/logger';
import { ERROR_LEVELS, SENTRY_CABINET } from '@user-portal/sentry-utils';
import { Button, Text } from '@user-portal/wikr-components';
import { trackGoToMainClick, trackProductNotFoundScreenLoad } from 'analytics/trackers/shop';
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';

import { PRIVATE } from 'router/routes';

import { MOCKED_PRODUCTS } from 'constants/products/upsell';

import sentry from 'services/Sentry/SentryInstance';

import { getProduct } from './helpers';
import ShopPage from './ShopPage';

import * as S from './styled';

export const Shop = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();

    const { productCode } = useParams<{ productCode: keyof typeof MOCKED_PRODUCTS }>();
    const product = getProduct(productCode);

    useEffect(() => {
        if (!product) {
            trackProductNotFoundScreenLoad(productCode ?? '');
            logger.error(`MB Portal: [UPSELL via CRM]: Product with code ${productCode} is not found`);
            sentry.logError(
                new Error('[UPSELL via CRM]: PRODUCT IS NOT FOUND'),
                SENTRY_CABINET,
                ERROR_LEVELS.CRITICAL,
                {
                    productCode,
                }
            );
        }
    }, []);

    const handleErrorProductClick = () => {
        trackGoToMainClick(productCode ?? '');
        navigate(PRIVATE.MAIN.path);
    };

    if (!product || !productCode) {
        return (
            <S.ProductErrorWrapper>
                <Text center type="h2" mb={30}>
                    Product is not found
                </Text>

                <Button onClick={handleErrorProductClick}>{t('Go to main')}</Button>
            </S.ProductErrorWrapper>
        );
    }

    return <ShopPage product={product} productCode={productCode} />;
};
